<template>
  <textarea v-model="innerValue" @input="updateValue" @blur="updateValue" @keydown.meta.enter="onKeyup($event)" :maxlength="max >= 0 ? max : false"></textarea>
</template>

<script>

  import "jquery.autogrow-textarea"

  export default {
    name: 'TextareaAutogrow',
    props: {
      value: {},
      max: {
        type: Number,
        default: -1
      }
    },
    data () {
      return {
        innerValue: (this.max >= 0)
          ? this.value.substring(0, this.max)
          : this.value
      }
    },
    mounted () {
      $(this.$el).autogrow({
        vertical: true,
        horizontal: false
      })
    },
    destroyed () {
      // $(this.$el).trigger("remove.autogrow")
    },
    methods: {
      updateValue () {
        this.$emit("input", this.innerValue)
      },
      onKeyup (event) {
        this.$emit('metaEnter')
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

  textarea {
    @include transition(border-color);
    display:block; width:100%; border:1px solid $color-gray; resize:none; font-size:90%; padding:.5em;
    &:hover, &:focus {
      border-color:$color-primary;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/textarea-autogrow.vue